// Define the debug settings as a const assertion
const DEBUG_SETTINGS = {
    DEBRIEF_PRECISE_TIME: 'debriefPreciseTime',
    DEBRIEF_APPROACH_DEBUG: 'debriefApproachDebug',
    // Add more settings as needed
} as const;

// Create a type from the values
type DebugSettingKey = (typeof DEBUG_SETTINGS)[keyof typeof DEBUG_SETTINGS];

// Create a type for the keys (if needed)
type DebugSettingName = keyof typeof DEBUG_SETTINGS;

export { DEBUG_SETTINGS };
export type { DebugSettingKey, DebugSettingName };
